(function () {
  "use strict";

  var STORAGE_KEY = "rds_marketing_journey_v1";
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var STUDIO_ORIGIN = "https://ai-sticker-studio-web.onrender.com";
  var EVENT_ENDPOINT = STUDIO_ORIGIN + "/api/marketing/events";
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  var CLICK_KEYS = ["gclid", "gbraid", "wbraid", "fbclid", "ttclid"];
  var UTM_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;
  var CLICK_PATTERN = /^[A-Za-z0-9._~-]+$/;
  var SELF_HOSTS = {
    "riderdecalstudio.com": true,
    "www.riderdecalstudio.com": true,
    "ai-sticker-studio-web.onrender.com": true
  };

  function privacyState() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== "function") return null;
    try {
      return {
        analytics: privacy.analyticsProcessingAllowed() === true,
        marketing: typeof privacy.marketingAllowed === "function" && privacy.marketingAllowed() === true
      };
    } catch (_) {
      return null;
    }
  }

  function randomJourneyKey() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    return Array.from(bytes, function (value) { return value.toString(16).padStart(2, "0"); })
      .join("").replace(/^(........)(....)(....)(....)(............)$/, "$1-$2-$3-$4-$5");
  }

  function journeyKey() {
    var now = Date.now();
    try {
      var current = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "null");
      if (current && typeof current.key === "string" && typeof current.createdAt === "number"
        && now - current.createdAt >= 0 && now - current.createdAt < MAX_AGE_MS) return current.key;
      var next = { key: randomJourneyKey(), createdAt: now };
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next.key;
    } catch (_) {
      return randomJourneyKey();
    }
  }

  function accepted(value, maximum, pattern, lowercase) {
    if (!value || value.length > maximum || !pattern.test(value)) return null;
    return lowercase ? value.toLowerCase() : value;
  }

  function referrerHost() {
    if (!document.referrer) return null;
    try {
      var host = new URL(document.referrer).hostname.toLowerCase();
      return SELF_HOSTS[host] ? null : host.slice(0, 253);
    } catch (_) {
      return null;
    }
  }

  function creativeIdentity(content) {
    if (!content) return null;
    var normalized = content.toLowerCase().replace(/[^a-z0-9]+/g, "-");
    if (/(^|-)a01(-|$)/.test(normalized)) return "A01";
    if (/(^|-)c02(-|$)/.test(normalized)) return "C02";
    if (/(^|-)f01(-|$)/.test(normalized)) return "F01";
    if (/(^|-)f02(-|$)/.test(normalized)) return "F02";
    return accepted(normalized, 128, UTM_PATTERN, true);
  }

  function touch(marketingAllowed) {
    var params = new URLSearchParams(window.location.search);
    var result = {
      utmSource: accepted(params.get("utm_source"), 64, UTM_PATTERN, true),
      utmMedium: accepted(params.get("utm_medium"), 64, UTM_PATTERN, true),
      utmCampaign: accepted(params.get("utm_campaign"), 128, UTM_PATTERN, true),
      utmContent: accepted(params.get("utm_content"), 128, UTM_PATTERN, true),
      utmTerm: accepted(params.get("utm_term"), 128, UTM_PATTERN, true),
      campaignId: accepted(params.get("campaign_id"), 128, UTM_PATTERN, true),
      adSetId: accepted(params.get("adset_id"), 128, UTM_PATTERN, true),
      adId: accepted(params.get("ad_id"), 128, UTM_PATTERN, true),
      creativeId: creativeIdentity(params.get("utm_content")),
      gclid: null,
      gbraid: null,
      wbraid: null,
      fbclid: null,
      ttclid: null,
      landingPath: window.location.pathname.slice(0, 512) || "/",
      referrerHost: referrerHost()
    };
    if (marketingAllowed) {
      result.gclid = accepted(params.get("gclid"), 256, CLICK_PATTERN, false);
      result.gbraid = accepted(params.get("gbraid"), 256, CLICK_PATTERN, false);
      result.wbraid = accepted(params.get("wbraid"), 256, CLICK_PATTERN, false);
      result.fbclid = accepted(params.get("fbclid"), 256, CLICK_PATTERN, false);
      result.ttclid = accepted(params.get("ttclid"), 256, CLICK_PATTERN, false);
    }
    return result;
  }

  function postLanding(key, state, currentTouch) {
    var body = JSON.stringify({
      schema: "rds-marketing-browser-event-v1",
      journeyKey: key,
      eventType: "rds:landing_view",
      styleId: null,
      analyticsAllowed: true,
      marketingAllowed: state.marketing,
      touch: currentTouch
    });
    window.fetch(EVENT_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
      keepalive: true,
      credentials: "omit"
    }).catch(function () {});
  }

  function publishShopifyLanding() {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== "function") return;
    try {
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "null");
      if (stored && stored.landingPublished === true) return;
      if (stored) {
        stored.landingPublished = true;
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      }
    } catch (_) {}
    try {
      var result = analytics.publish("rds:landing_view", { schema: "rds-marketing-event-v1" });
      if (result && typeof result.catch === "function") result.catch(function () {});
    } catch (_) {}
  }

  function studioLinks() {
    return document.querySelectorAll('a[href^="' + STUDIO_ORIGIN + '/studio"]');
  }

  function cleanStudioLinks() {
    studioLinks().forEach(function (link) {
      try {
        var url = new URL(link.href);
        url.search = "";
        link.href = url.toString();
      } catch (_) {}
    });
  }

  function bridgeStudioLinks(key, state, currentTouch) {
    studioLinks().forEach(function (link) {
      try {
        var url = new URL(link.href);
        url.search = "";
        url.searchParams.set("rds_journey", key);
        url.searchParams.set("rds_analytics", "1");
        url.searchParams.set("rds_marketing", state.marketing ? "1" : "0");
        url.searchParams.set("rds_landing", currentTouch.landingPath);
        if (currentTouch.referrerHost) url.searchParams.set("rds_referrer", currentTouch.referrerHost);
        var names = ["utmSource", "utmMedium", "utmCampaign", "utmContent", "utmTerm"];
        UTM_KEYS.forEach(function (parameter, index) {
          if (currentTouch[names[index]]) url.searchParams.set(parameter, currentTouch[names[index]]);
        });
        CLICK_KEYS.forEach(function (parameter) {
          if (currentTouch[parameter]) url.searchParams.set(parameter, currentTouch[parameter]);
        });
        if (currentTouch.campaignId) url.searchParams.set("rds_campaign_id", currentTouch.campaignId);
        if (currentTouch.adSetId) url.searchParams.set("rds_adset_id", currentTouch.adSetId);
        if (currentTouch.adId) url.searchParams.set("rds_ad_id", currentTouch.adId);
        if (currentTouch.creativeId) url.searchParams.set("rds_creative_id", currentTouch.creativeId);
        link.href = url.toString();
      } catch (_) {}
    });
  }

  function loadPrivacyAndInitialize() {
    cleanStudioLinks();
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== "function") return;
    try {
      shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
        if (error) {
          cleanStudioLinks();
          return;
        }
        initialize();
      });
    } catch (_) {
      cleanStudioLinks();
    }
  }

  function initialize() {
    var state = privacyState();
    if (!state || !state.analytics) {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (_) {}
      cleanStudioLinks();
      return;
    }
    var key = journeyKey();
    var currentTouch = touch(state.marketing);
    bridgeStudioLinks(key, state, currentTouch);
    postLanding(key, state, currentTouch);
    publishShopifyLanding();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", loadPrivacyAndInitialize, { once: true });
  else loadPrivacyAndInitialize();
  document.addEventListener("visitorConsentCollected", initialize);
})();
